import axios from 'axios';
import { requestHeaders } from './HttpClient';
import { apiBackendBaseUrl } from './envsetup';
import keycloak from 'Keycloak';
export default axios.create({
  baseURL: apiBackendBaseUrl,
  headers: requestHeaders,
});
